<div class="course-wrapper" *ngIf="courses">
    <cn-course-display [courses]="courses" [columns]="6" [grid]="true" [showFilters]="false" [allowFavorites]="false" [autoPlay]="true" [standalone]="true"></cn-course-display>
</div>